import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

/**
 * Renders the before/after reservation impact for a cancel or edit.
 *
 * Props:
 *  - rows : output of computeReservationImpact()
 *  - mode : "cancel" | "edit"
 */
const ReservationImpactTable = ({ rows, mode }) => {
  if (!rows || rows.length === 0) {
    return (
      <Typography sx={{ mt: 1, color: "text.secondary" }}>
        No reserved stock is affected.
      </Typography>
    );
  }

  const reservedText = (r) => {
    if (mode === "cancel") {
      return `${r.oldReserved} → 0  (release ${r.oldReserved})`;
    }
    if (mode === "create") {
      return `reserve ${r.newReserved}`;
    }
    const deltaLabel =
      r.delta === 0
        ? " (no change)"
        : r.delta > 0
        ? `  (${r.delta} more reserved)`
        : `  (${Math.abs(r.delta)} released)`;
    return `${r.oldReserved} → ${r.newReserved}${deltaLabel}`;
  };

  return (
    <Box sx={{ mt: 1, overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Product</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Store</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>
              In Stock
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: 600 }}>
              Reserved
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: 600 }}>
              Available
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => {
            const shortfall = r.availableAfter < 0;
            return (
              <TableRow key={r.product_id}>
                <TableCell>{r.product_name}</TableCell>
                <TableCell>{r.store_name || "-"}</TableCell>
                <TableCell align="right">{r.onHand}</TableCell>
                <TableCell align="center">{reservedText(r)}</TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: 600,
                    color: shortfall
                      ? "#c62828"
                      : r.availableAfter > r.availableBefore
                      ? "#2e7d32"
                      : "inherit",
                  }}
                >
                  {r.availableBefore} → {r.availableAfter}
                  {shortfall ? " ⚠" : ""}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ReservationImpactTable;
